<div class="leaflet-control leaflet-control-incident" id="incidentControl" [hidden]="hideMobile">
  <a class="leaflet-control-incident-button leaflet-control-pill"
    (click)="onClick($event)"
    (keydown.enter)="onClick($event)"
    (keydown.space)="onClick($event); $event.preventDefault()"
    role="button"
    tabindex="0"
    [attr.aria-label]="translateService.get(translations.map.incidentControl.tooltip) | async | translate"
    [matTooltip]="translateService.get(translations.map.incidentControl.tooltip) | async | translate" 
    fxLayoutAlign="start center">
    <zui-icon icon="image_search"></zui-icon>
    <span class="leaflet-control-incident-button-label" fxShow.xs="false">
      {{ translateService.get(translations.map.incidentControl.locator) | async | translate }}
    </span>
  </a>
</div>